<template >
    <div id="slide_box" class="slide5">
        <div id="slide_content" :style="{background: siteCodeInfo[0].BACK_COLOR}">
            <div class="slide_block" id="slide5" :class="getShowClass()">
                 <div class="slide_animate_block">
                    <form method='GET' @submit.prevent="submitSpecificDatetimeForm">
                        <div class="bg" :style="{background: siteCodeInfo[0].BACK_COLOR}">
                            <div class="wrap01">
                                <h2 class="stitle"><span>回収の希望日時を</span><br><span>選択してください。</span></h2>
                                <CommonErrorMsgArea />
                                <div class="form_block_04">
                                    <div class="calender">
                                        <div class="datepicker-group">
                                            <div id="dat">
                                                <div v-for="(month, indexMonth) in calendar" :key="indexMonth">
                                                    <div class="datepicker-title" :class="{'calendarYearMonth': indexMonth > 0}">{{month.yearMonth}}</div>
                                                    <table class="datepicker-calendar">
                                                        <thead>
                                                            <tr>
                                                                <th v-for="(day, index) in dayStrArray" :key="index" scope="col" class="datepicker-week-end">
                                                                    <span :title="day.name">{{ day.name }}</span>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(week, indexWeek) in month.weekRows" :key="indexWeek">
                                                                <td v-for="(day, indexDay) in week" :key="indexDay" :class="{'blank': day == ''}">
                                                                    <input v-if="day != ''" type="radio" :id="'date' + day.date" name="pickupDate" v-on:click="selectDate(day.year, day.month, day.date)"
                                                                    :checked="specificDate == day.year + '/' + day.month + '/' + day.date" :disabled="day.service == 0" data-confirm="pickupDate">
                                                                    <label v-if="day != ''" :for="'date' + day.date" :class="{'invalid': day.service == 0}" :style="{backgroundColor :specificDate == day.year + '/' + day.month + '/' + day.date? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ day.date }}</label>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p class="error" v-if="error.invalid_specificDate">{{$msg.ERROR.MSG_0005}}</p>
                                    <div class="time_box">
                                        <p class="time_title">●回収希望時間帯</p>
                                        <div class="form-Radio-02 time_content">
                                            <label v-for="(time, index) in pickup_times" :key="index">
                                                <input type="radio" name="time" v-on:click="selectTime(time)"
                                                :checked="specificTime.CODE == time.CODE" :disabled="time.service == 0">
                                                <span :class="{'input_txt': true, 'invalid': time.service == 0}" :style="{backgroundColor :specificTime.CODE == time.CODE? siteCodeInfo[0].SELECTED_BTN_COLOR:'', borderColor :specificTime.CODE == time.CODE? siteCodeInfo[0].SELECTED_BTN_COLOR:''}">{{ time.CODE_NM }}</span>
                                            </label>
                                        </div>
                                    </div>
                                    <p class="error" v-if="error.invalid_specificTime">{{$msg.ERROR.MSG_0006}}</p>
                                </div>
                                <p class="next_page"><button type="submit" class="form-Button-01 move_slide move_category" :style="{backgroundColor : siteCodeInfo[0].NEXT_PAGE_BTN_COLOR}" data-toslide="slide6" data-categorynum="1">お客様情報の入力へ</button></p>
                                <div class="link_box">
                                    <p class="back_page"><span class="form-Button-back move_slide" data-toslide="slide4" @click="pageBack">戻る</span></p>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SpecificDatetimeForm from '../../js/SpecificDatetimeForm'
import CommonErrorMsgArea from '@/components/sp/CommonErrorMsgArea'

export default {
    props: {
        siteCodeInfo: Array,
    },
    data() {
        return {
            is_large: 0,//大型判定
            dayStrArray: SpecificDatetimeForm.common.constant.DAY_STR_ARRSY,//曜日の配列
            sgm_pickup_service: {},//回収可能日
            pickup_times: [],//回収可能時間帯
            calendar: [],//カレンダー
            specificDate: '',//選択された回収希望日
            specificTime: '',//選択された回収希望時間帯
            nowYearMonth:'',//現在の年月
            error: {
                invalid_specificDate: false,
                invalid_specificTime: false
            },
            mediumView: 0,
            smallView: 0,
        }
    },
    created() {
        SpecificDatetimeForm.inputRetention(this)
    },
    mounted() {
        SpecificDatetimeForm.isLarge(this)
        SpecificDatetimeForm.getService(this)
    },
    methods: {
        selectDate(year, month, date) {
            SpecificDatetimeForm.selectDate(this, year, month, date)
        },
        selectTime(time) {
            SpecificDatetimeForm.selectTime(this, time)
        },
        submitSpecificDatetimeForm() {
            SpecificDatetimeForm.submitSpecificDatetimeForm(this, SpecificDatetimeForm.common.constant.CUSTOMER_INFORMATION_PATH)
        },
        pageBack() {
            SpecificDatetimeForm.pageBack(this)
        }
    },
    components: { CommonErrorMsgArea }
}

</script>
